/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { SystemVarsRestService } from '@gh/builder-shared-data';
import { Observable } from 'rxjs';

@Injectable()
export class ColorSchemePickerBusinessService {
  constructor(private systemVarsRest: SystemVarsRestService) {
  }

  update(scheme: string): Observable<string> {
    return this.systemVarsRest.modifyColorScheme(scheme);
  }
}
